
  import {Component} from 'vue-property-decorator';

  import SelectorSite from '@/site/components/SelectorSite.vue';

  import Account from './Account.vue';
  import AffluenceModal from './AffluenceModal.vue';
  import BaseService from './BaseService.vue';

  @Component({components: {SelectorSite, AffluenceModal, Account}})
  export default class AppBar extends BaseService {}
